import { Card, CardActions, CardContent, CardHeader, Divider, Grid, Typography } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import { useGenericStyles } from 'common/genericStyles';
import {
  InstrumentoFinanceiroApiResponse,
  InstrumentoFinanceiro,
  Perfil,
  CraApiResponse,
  CdcaApiResponse,
  DebentureApiResponse,
  NotaComercialApiResponse,
  CriApiResponse,
  CertificadoRecebiveisApiResponse,
  GrupoAcesso,
  CotasDeFundoApiResponse,
} from 'common/genericTypes';
import { MdSpace, SmSpace, TextButton, Button } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'store/index';
import moment from 'moment';

const ListaDeRacunhos: React.FC = () => {
  const classes = useGenericStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);
  const isUsuarioOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;    
  const getRascunhosByFilter = useSelector((state: RootState) => state.instrumentoApi.getRascunhosByFilter);
  const getRascunhoByDraftId = useSelector((state: RootState) => state.instrumentoApi.getRascunhoByDraftId);
  const isUsuarioOperacaoMaster = isUsuarioOperacoes && useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Master);

  const pageSize = 9;
  const [instrumentoList, setInstrumentoList] = useState<Array<InstrumentoFinanceiroApiResponse>>([]);
  const [page, setPage] = useState<number>(0);
  const [haveMoreElements, setHaveMoreElements] = useState<boolean>(true);

  const getInstrumentoList = async (filterPage: number) => {
    try {
      const result = await getRascunhosByFilter(dispatch, { pageSize, haveMoreElements, page: filterPage }, true);
      setInstrumentoList(result.rascunhos);
      setHaveMoreElements(result.filter.haveMoreElements);
      setPage(result.filter.page);
    } catch (error) {}
  };

  const handleContinuarCadastro = async (instrumento: InstrumentoFinanceiroApiResponse) => {
    if (instrumento.draft) {
      switch (instrumento.tipoInstrumentoFinanceiro) {
        case InstrumentoFinanceiro.Cdca:
          const cdca = await getRascunhoByDraftId<CdcaApiResponse>(dispatch, instrumento.draft.id, true);
          history.push(`/instrumentos/gerenciar/cadastro/cdca`, { cdcaRascunho: cdca });
          break;
        case InstrumentoFinanceiro.CotasDeFundo:
          const cotasDeFundo = await getRascunhoByDraftId<CotasDeFundoApiResponse>(dispatch, instrumento.draft.id, true);
          history.push(`/instrumentos/gerenciar/cadastro/cotas-de-fundo`, { cotasDeFundoRascunho: cotasDeFundo });
          break;
        case InstrumentoFinanceiro.Cra:
          const cra = await getRascunhoByDraftId<CraApiResponse>(dispatch, instrumento.draft.id, true);
          history.push(`/instrumentos/gerenciar/cadastro/cra`, { craRascunho: cra });
          break;
        case InstrumentoFinanceiro.Cri:
          const cri = await getRascunhoByDraftId<CriApiResponse>(dispatch, instrumento.draft.id, true);
          history.push(`/instrumentos/gerenciar/cadastro/cri`, { criRascunho: cri });
          break;
        case InstrumentoFinanceiro.Debenture:
          const debenture = await getRascunhoByDraftId<DebentureApiResponse>(dispatch, instrumento.draft.id, true);
          history.push(`/instrumentos/gerenciar/cadastro/debenture`, { debentureRascunho: debenture });
          break;
        case InstrumentoFinanceiro.NotaComercial:
          const nc = await getRascunhoByDraftId<NotaComercialApiResponse>(dispatch, instrumento.draft.id, true);
          history.push(`/instrumentos/gerenciar/cadastro/nota-comercial`, { ncRascunho: nc });
          break;
        case InstrumentoFinanceiro.CertificadoRecebiveis:
          const cr = await getRascunhoByDraftId<CertificadoRecebiveisApiResponse>(dispatch, instrumento.draft.id, true);
          history.push(`/instrumentos/gerenciar/cadastro/certificado-recebiveis`, { crRascunho: cr });
          break;
        default:
          break;
      }
    }
  };

  const handleVoltarAoInicio = () => {
    setPage(0);
    setHaveMoreElements(true);
    getInstrumentoList(0);
  };

  useEffect(() => {
    getInstrumentoList(0);
  }, []);

  return (
    <>
      <Grid container spacing={3}>
        {instrumentoList.map((instrumento) => (
          <Grid item lg={4} key={instrumento.draft?.id} style={{ position: 'relative' }}>
            <Card variant="outlined">
              <CardHeader
                title={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="subtitle1">{instrumento.codigo}</Typography>
                  </div>
                }
              />
              <CardContent style={{ paddingTop: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden' }}>
                  <Typography variant="h3" className={classes.wrapTxt}>
                    {instrumento.razaoSocialEmissor ?? ''}
                  </Typography>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="body2" className={classes.wrapTxt}>
                    {`Emissão ${instrumento.numeroEmissao} - Série ${instrumento.numeroSerie}`}
                  </Typography>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="body2">
                    {`Última Alteração: ${moment(instrumento.draft?.updateDate).format('LLL') ?? ''}`}
                  </Typography>
                </div>
                <SmSpace />
                <Divider />
                <CardActions style={{ padding: 0, display: 'flex', justifyContent: 'flex-end' }}>
                  <TextButton
                    size="medium"
                    onClick={() => handleContinuarCadastro(instrumento)}
                    endIcon={<Edit color="primary" htmlColor="black" />}
                    style={{ marginLeft: 'auto' }}
                    disabled={isUsuarioLeitura || isUsuarioOperacaoMaster}
                  >
                    {'Continuar Cadastro'}
                  </TextButton>
                </CardActions>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <MdSpace />
      <Grid container justifyContent={'center'} spacing={3}>
        <Grid item lg={3} xl={2}>
          <Button variant="outlined" color="secondary" onClick={() => handleVoltarAoInicio()} disabled={page === 0}>
            {'Voltar ao início'}
          </Button>
        </Grid>
        <Grid item lg={2} xl={2}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => getInstrumentoList(page - 1)}
            disabled={page === 0}
          >
            {'Página anterior'}
          </Button>
        </Grid>
        <Grid item lg={2} xl={2}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => getInstrumentoList(page + 1)}
            disabled={!haveMoreElements}
          >
            {'Próxima página'}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default ListaDeRacunhos;
